import { buzz, chime, noise, tone } from '../synth';

/** Beer Pong's sounds, synthesized on the fly (see `../synth.ts`). All best effort. */

/** The ball leaving your hand. */
export function playToss(): void {
  noise({ dur: 0.22, gain: 0.08, filter: 700, filterTo: 2200, q: 0.6, attack: 0.08 });
}

/** Ping-pong ball on plywood. Softer for each later, lower bounce. */
export function playBounce(strength: number): void {
  const g = Math.min(0.22, 0.06 + strength * 0.12);
  tone({ freq: 1900, to: 900, type: 'triangle', dur: 0.045, gain: g });
  noise({ dur: 0.03, gain: g * 0.6, filter: 3500, q: 2 });
}

/** The plasticky "tik" of a rim — two quick hits so it reads as a rattle. */
export function playRim(): void {
  tone({ freq: 2600, to: 1900, type: 'square', dur: 0.035, gain: 0.05 });
  tone({ freq: 2300, to: 1700, type: 'square', dur: 0.03, gain: 0.035, delay: 0.06 });
  buzz(8);
}

/** In the cup: a wet plop, then a little rising "yes". */
export function playSplash(lastCup: boolean): void {
  noise({ dur: 0.32, gain: 0.3, filter: 900, filterTo: 300, q: 1.1, attack: 0.006 });
  tone({ freq: 240, to: 520, dur: 0.12, gain: 0.12 });
  if (lastCup) chime([523, 659, 784, 1047], 0.09);
  else chime([784, 988], 0.07);
  buzz(lastCup ? [30, 60, 40, 60, 80] : [25, 40, 25]);
}
